import axios from 'axios';

// Automatically detect environment and set baseURL
const isLocalhost = window.location.hostname === 'localhost' ||
                    window.location.hostname === '127.0.0.1' ||
                    window.location.hostname === '';

const baseURL = isLocalhost
  ? 'https://4sightoperations.com/'
  : '/';

const api = axios.create({
  baseURL: baseURL,
});

// This is your existing REQUEST interceptor. It is correct and handles adding the token.
api.interceptors.request.use(
  (config) => {
    // Note: It's good practice to use the same key casing, e.g., 'token' or 'Token'.
    // I'll stick with 'Token' as you have it.
    const token = localStorage.getItem('Token'); 
    
    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);


// --- ADD THIS RESPONSE INTERCEPTOR TO HANDLE BACKEND ERRORS ---
// This part inspects incoming responses and modifies the error message if needed.
api.interceptors.response.use(
  // If the response is successful (status 2xx), just pass it through.
  (response) => response,
  
  // If the response is an error...
  (error) => {
    // Check if the server responded with our custom JSON error format { "error": "..." }
    if (error.response && error.response.data && error.response.data.error) {
      // Overwrite the generic Axios error message with the specific one from our backend.
      error.message = error.response.data.error;
    }
    
    // IMPORTANT: Re-reject the promise with the modified error object.
    // This ensures that the .catch() block in your component receives it.
    return Promise.reject(error);
  }
);


export default api;
